import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import './AboutPage.css'; // For specific styling
import aboutImg from '../assets/Images/Double.png'

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>General Pest Control Services</title>
        <meta name="description" content="Learn about our mission, values, and commitment to providing professional pest control services in Jodhpur. Trust our experienced team for reliable pest management solutions." />
        <meta name="keywords" content="about pest control, company mission, values, professional pest management, Jodhpur pest control company" />
      </Helmet>
      <div className="about-page-container py-5">
        <div className="container">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center mb-5"
        >
          <h1 className="display-4 fw-bold page-title fs-3">General Pest Control Services
          </h1>
          <p className="lead text-muted">Understanding Our Mission and Commitment to You</p>
        </motion.div>

        {/* Main Section – What is Pest Control & Why It Matters */}
        <section className="pest-control-info-section mb-5">
          <motion.h2 
            className="text-center mb-5 section-title-about"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Pest Control 
          </motion.h2>
          <div className="row align-items-center g-5">
            <motion.div 
              className="col-lg-7 order-lg-1"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
              <h3 className="fw-semibold mb-3">The Essentials of Pest Management</h3>
              <p className="text-muted">
                Pest control is the regulation or management of a species defined as a pest, a member of the animal kingdom that impacts adversely on human activities. It involves a comprehensive approach to prevent, reduce, or eliminate pest populations.
              </p>
              <h4 className="fw-semibold mt-4 mb-2">Why is it Crucial?</h4>
              <p className="text-muted">
                Effective pest control is vital for maintaining health, hygiene, and safety in homes, offices, and commercial spaces. Pests can transmit diseases, contaminate food, and cause significant structural damage to properties.
              </p>
              <h5 className="fw-semibold mt-3 mb-1">Common Pests We Handle:</h5>
              <ul className="list-styled text-muted">
                <li>Termites: Silent destroyers of wooden structures.</li>
                <li>Rodents (Rats & Mice): Carriers of diseases and property damagers.</li>
                <li>Cockroaches: Spread bacteria and trigger allergies.</li>
                <li>Bed Bugs: Cause discomfort and skin irritations.</li>
                <li>Mosquitoes & Flies: Transmit various illnesses.</li>
                <li>Ants, Spiders, and more.</li>
              </ul>
              <h5 className="fw-semibold mt-3 mb-1">Risks of Neglecting Pest Issues:</h5>
              <p className="text-muted">
                Ignoring pests can lead to severe health hazards, costly property damage, tarnished reputations for businesses, and overall poor hygiene conditions.
              </p>
              <h5 className="fw-semibold mt-3 mb-1">The Importance of Certified Professionals:</h5>
              <p className="text-muted">
                Hiring certified professionals ensures that pest control is performed safely and effectively, using industry-approved methods and products that are safe for your family, pets, and the environment.
              </p>
              <h5 className="fw-semibold mt-3 mb-1">Our Safe & Efficient Approach:</h5>
              <p className="text-muted">
                At PestGuard, we prioritize Integrated Pest Management (IPM) techniques. This involves thorough inspections, identification of pests, targeted treatments, and preventative measures, all while minimizing risks to people and the environment. Our technicians are trained and certified to deliver the highest standard of service.
              </p>
            </motion.div>
            <motion.div 
              className="col-lg-5 order-lg-2 text-center"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.5 }}
            >
              <img 
                src={aboutImg}
                alt="Pest Control Professionals at Work"
                className="img-fluid rounded shadow-lg about-page-image"
              />
            </motion.div>
          </div>
          {/* Booking button removed as requested */}
        </section>

        {/* Other sections for About Page can be added here later */}
        {/* e.g., Our Mission, Our Values, Team Highlights (if different from homepage) */}
      </div>
    </div>
  </>
  );
};

export default AboutPage;
